// extracted by mini-css-extract-plugin
module.exports = {"labelTipoPessoa":"Registro_labelTipoPessoa__1-eOm"};